import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withKeys as _withKeys, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "d-flex align-items-center flex-wrap" }
const _hoisted_2 = {
  id: "split-container",
  ref: "splitContainer"
}
const _hoisted_3 = {
  id: "table-wrapper-table1",
  class: "table-wrapper"
}
const _hoisted_4 = {
  key: 0,
  class: "text-center my-1"
}
const _hoisted_5 = {
  key: 1,
  class: "text-center"
}
const _hoisted_6 = { class: "text-danger my-1" }
const _hoisted_7 = { class: "float-end" }
const _hoisted_8 = { class: "float-end" }
const _hoisted_9 = { class: "d-flex justify-content-between align-items-end flex-wrap" }
const _hoisted_10 = { class: "me-3" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 2 }
const _hoisted_14 = { class: "d-flex justify-content-between align-items-center mt-2" }
const _hoisted_15 = {
  key: 0,
  style: {"color":"#212529"}
}
const _hoisted_16 = {
  class: "d-none d-lg-block ms-1",
  style: {"margin-top":"0.075rem"}
}
const _hoisted_17 = {
  class: "d-none d-sm-block d-lg-none ms-1",
  style: {"margin-top":"0.075rem"}
}
const _hoisted_18 = { class: "d-flex align-items-center flex-wrap" }
const _hoisted_19 = {
  ref: "buttonGroupTable2",
  class: "d-flex justify-content-end align-items-center mb-2"
}
const _hoisted_20 = { class: "bottom-panel-dropdown" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { class: "table-wrapper" }
const _hoisted_23 = {
  key: 0,
  class: "text-center my-1"
}
const _hoisted_24 = {
  key: 1,
  class: "text-center"
}
const _hoisted_25 = { class: "text-danger my-1" }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { key: 1 }
const _hoisted_28 = { key: 2 }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = ["href"]
const _hoisted_31 = ["title"]
const _hoisted_32 = { key: 0 }
const _hoisted_33 = ["href"]
const _hoisted_34 = { key: 1 }
const _hoisted_35 = ["href"]
const _hoisted_36 = { key: 0 }
const _hoisted_37 = {
  key: 0,
  class: "text-center"
}
const _hoisted_38 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_39 = ["href"]
const _hoisted_40 = { class: "text-end" }
const _hoisted_41 = { key: 1 }
const _hoisted_42 = ["href"]
const _hoisted_43 = { key: 0 }
const _hoisted_44 = {
  key: 0,
  class: "text-center"
}
const _hoisted_45 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_46 = ["href"]
const _hoisted_47 = { class: "text-end" }
const _hoisted_48 = { key: 1 }
const _hoisted_49 = ["href"]
const _hoisted_50 = { class: "d-flex" }
const _hoisted_51 = { key: 0 }
const _hoisted_52 = { key: 0 }
const _hoisted_53 = {
  key: 1,
  class: "fas fa-edit"
}
const _hoisted_54 = { key: 1 }
const _hoisted_55 = { key: 0 }
const _hoisted_56 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_57 = { key: 0 }
const _hoisted_58 = {
  key: 0,
  class: "overflow-auto",
  style: {"max-height":"200px","white-space":"pre-wrap"}
}
const _hoisted_59 = { class: "d-flex align-items-center" }
const _hoisted_60 = { class: "mt-3" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_b_dropdown_item = _resolveComponent("b-dropdown-item")
  const _component_b_dropdown = _resolveComponent("b-dropdown")
  const _component_b_button = _resolveComponent("b-button")
  const _component_b_button_group = _resolveComponent("b-button-group")
  const _component_b_form_input = _resolveComponent("b-form-input")
  const _component_b_input_group = _resolveComponent("b-input-group")
  const _component_b_form_group = _resolveComponent("b-form-group")
  const _component_b_modal = _resolveComponent("b-modal")
  const _component_b_spinner = _resolveComponent("b-spinner")
  const _component_b_td = _resolveComponent("b-td")
  const _component_b_tr = _resolveComponent("b-tr")
  const _component_v_multiselect = _resolveComponent("v-multiselect")
  const _component_b_table = _resolveComponent("b-table")
  const _component_b_overlay = _resolveComponent("b-overlay")
  const _component_b_form_textarea = _resolveComponent("b-form-textarea")
  const _component_b_form_checkbox = _resolveComponent("b-form-checkbox")
  const _component_b_dropdown_divider = _resolveComponent("b-dropdown-divider")
  const _component_b_dropdown_form = _resolveComponent("b-dropdown-form")
  const _component_b_popover = _resolveComponent("b-popover")
  const _component_b_form_select_option = _resolveComponent("b-form-select-option")
  const _component_b_form_select = _resolveComponent("b-form-select")
  const _component_b_form = _resolveComponent("b-form")
  const _directive_b_modal = _resolveDirective("b-modal")

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[23] || (_cache[23] = _createElementVNode("h1", { class: "me-4" }, " Kapazitätsberechnung ", -1 /* CACHED */)),
      _createVNode(_component_b_button_group, { class: "mb-2" }, {
        default: _withCtx(() => [
          _createVNode(_component_b_dropdown, {
            text: $data.currentSemester.short
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.semesters, (semester) => {
                return (_openBlock(), _createBlock(_component_b_dropdown_item, {
                  key: semester.id,
                  onClick: $event => ($options.fetchData(semester))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(semester.short), 1 /* TEXT */)
                  ]),
                  _: 2 /* DYNAMIC */
                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]))
              }), 128 /* KEYED_FRAGMENT */))
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["text"]),
          _createVNode(_component_b_button, {
            title: $options.durationFormatTooltipText,
            onClick: _cache[0] || (_cache[0] = $event => ($data.formatDurationsAsHours = !$data.formatDurationsAsHours))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString($data.formatDurationsAsHours ? '[hh:mm]' : '[h]'), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["title"])
        ]),
        _: 1 /* STABLE */
      }),
      _withDirectives((_openBlock(), _createBlock(_component_b_button, {
        class: "mb-2 ms-auto",
        style: {"background-color":"#2e75b6","color":"white"}
      }, {
        default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
          _createTextVNode(" Kapazität ", -1 /* CACHED */)
        ]))]),
        _: 1 /* STABLE */
      })), [
        [_directive_b_modal, void 0, "capacity-modal"]
      ]),
      _createVNode(_component_b_modal, {
        id: "capacity-modal",
        ref: "capacityModal",
        title: "Kapazität eingeben (Std.)",
        "cancel-title": "Schließen",
        onOk: $options.submitCapacity,
        onShow: _cache[2] || (_cache[2] = $event => ($data.capacityInputValue=$data.capacity)),
        onHidden: _cache[3] || (_cache[3] = $event => ($data.capacityInputState=null))
      }, {
        default: _withCtx(() => [
          _createCommentVNode("suppress JSValidateTypes "),
          _createVNode(_component_b_form_group, {
            state: $data.capacityInputState,
            "invalid-feedback": "Kein gültiger Wert."
          }, {
            default: _withCtx(() => [
              _createVNode(_component_b_input_group, { append: "Std." }, {
                default: _withCtx(() => [
                  _createCommentVNode("suppress JSValidateTypes "),
                  _createVNode(_component_b_form_input, {
                    modelValue: $data.capacityInputValue,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($data.capacityInputValue) = $event)),
                    type: "number",
                    state: $data.capacityInputState,
                    min: "0",
                    placeholder: "0,00",
                    style: {"appearance":"textfield","text-align":"right"}
                  }, null, 8 /* PROPS */, ["modelValue", "state"])
                ]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["state"])
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["onOk"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_b_overlay, {
        id: "split-panel-top",
        class: "split-panel",
        show: $data.isBusyTable1
      }, {
        overlay: _withCtx(() => [
          _createVNode(_component_b_spinner, {
            small: "",
            type: "grow",
            variant: "secondary"
          }),
          _createVNode(_component_b_spinner, {
            style: {"animation-delay":"0.1s"},
            small: "",
            type: "grow",
            variant: "secondary"
          }),
          _createVNode(_component_b_spinner, {
            style: {"animation-delay":"0.2s"},
            small: "",
            type: "grow",
            variant: "secondary"
          })
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_b_table, {
              id: "table1",
              ref: "table1",
              busy: $data.isBusyTable1,
              "onUpdate:busy": _cache[8] || (_cache[8] = $event => (($data.isBusyTable1) = $event)),
              class: "bootstrap-vue-table-borders",
              striped: "",
              hover: "",
              small: "",
              responsive: "",
              "sticky-header": "100%",
              "head-variant": "dark",
              "primary-key": "contractType",
              fields: $data.fieldsTable1,
              items: $options.filteredItemsTable1,
              "show-empty": ""
            }, {
              "table-busy": _withCtx(() => [...(_cache[24] || (_cache[24] = [
                _createElementVNode("div", { class: "text-center my-3" }, " wird geladen... ", -1 /* CACHED */)
              ]))]),
              empty: _withCtx(() => [
                (!$data.errorTable1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, " Keine passenden Ergebnisse gefunden. "))
                  : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, " Ein Fehler ist aufgetreten (" + _toDisplayString($data.errorTable1.message) + "). ", 1 /* TEXT */),
                      _createVNode(_component_b_button, {
                        onClick: _cache[4] || (_cache[4] = $event => ($options.fetchDataTable1()))
                      }, {
                        default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                          _createElementVNode("i", { class: "fa-solid fa-rotate-right me-1" }, null, -1 /* CACHED */),
                          _createTextVNode("Erneut versuchen. ", -1 /* CACHED */)
                        ]))]),
                        _: 1 /* STABLE */
                      })
                    ]))
              ]),
              "thead-top": _withCtx(() => [
                _createVNode(_component_b_tr, { style: {"--bs-table-bg":"#ed7d31","font-weight":"bold"} }, {
                  default: _withCtx(() => [
                    _createVNode(_component_b_td, { colspan: "4" }, {
                      default: _withCtx(() => [
                        _cache[26] || (_cache[26] = _createTextVNode(" Differenz ", -1 /* CACHED */)),
                        _createElementVNode("span", _hoisted_7, _toDisplayString($options.formatDuration($data.capacity - $options.columnSumsTable1.compensationLevels)), 1 /* TEXT */)
                      ]),
                      _: 1 /* STABLE */
                    })
                  ]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_b_tr, { style: {"--bs-table-bg":"#f2f2f2","--bs-table-color":"black","font-weight":"bold"} }, {
                  default: _withCtx(() => [
                    _createVNode(_component_b_td, { colspan: "4" }, {
                      default: _withCtx(() => [
                        _cache[27] || (_cache[27] = _createTextVNode(" Kapazität ", -1 /* CACHED */)),
                        _createElementVNode("span", _hoisted_8, _toDisplayString(($data.capacity !== null) ? $options.formatDuration($data.capacity) : 'n.A.'), 1 /* TEXT */)
                      ]),
                      _: 1 /* STABLE */
                    })
                  ]),
                  _: 1 /* STABLE */
                }),
                _createVNode(_component_b_tr, { style: {"--bs-table-bg":"#d0cece","--bs-table-color":"black","font-weight":"bold"} }, {
                  default: _withCtx(() => [
                    _createVNode(_component_b_td, null, {
                      default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
                        _createTextVNode("Gesamtsummen", -1 /* CACHED */)
                      ]))]),
                      _: 1 /* STABLE */
                    }),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.columnSumsTable1, (value, key) => {
                      return (_openBlock(), _createBlock(_component_b_td, {
                        key: key,
                        class: "text-end"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString($options.formatDuration(value)), 1 /* TEXT */)
                        ]),
                        _: 2 /* DYNAMIC */
                      }, 1024 /* DYNAMIC_SLOTS */))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              "head(contractType)": _withCtx((data) => [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, _toDisplayString(data.field.label), 1 /* TEXT */),
                  _createVNode(_component_v_multiselect, {
                    modelValue: $data.filterTable1,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => (($data.filterTable1) = $event)),
                    options: $options.contractTypeMultiselectOptions,
                    "track-by": "id",
                    label: "name",
                    multiple: true,
                    "close-on-select": false,
                    placeholder: "Vertragstyp(en) auswählen",
                    "select-label": "Eintrag auswählen",
                    "selected-label": "✓",
                    "deselect-label": "Auswahl aufheben",
                    style: {"width":"216px"},
                    onClick: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop"]))
                  }, {
                    placeholder: _withCtx(() => [...(_cache[29] || (_cache[29] = [
                      _createElementVNode("span", { class: "d-none d-lg-flex" }, "Vertragstyp(en) auswählen", -1 /* CACHED */),
                      _createElementVNode("span", { class: "d-flex d-lg-none" }, "Auswahl", -1 /* CACHED */)
                    ]))]),
                    selection: _withCtx(({values, isOpen}) => [
                      (values.length === 1 && !isOpen)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(values[0].name), 1 /* TEXT */))
                        : (values.length > 1 && !isOpen)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(values.length) + " Vertragstypen", 1 /* TEXT */))
                          : (_openBlock(), _createElementBlock("span", _hoisted_13))
                    ]),
                    beforeList: _withCtx(() => [
                      _createElementVNode("li", {
                        class: "multiselect__option",
                        onClick: _cache[5] || (_cache[5] = $event => ($data.filterTable1 = []))
                      }, [...(_cache[30] || (_cache[30] = [
                        _createElementVNode("i", { class: "fas fa-times" }, null, -1 /* CACHED */),
                        _createTextVNode(" Filter löschen ", -1 /* CACHED */)
                      ]))])
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["modelValue", "options"])
                ])
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["busy", "fields", "items"])
          ])
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["show"]),
      _cache[59] || (_cache[59] = _createElementVNode("div", { id: "separator" }, null, -1 /* CACHED */)),
      _createVNode(_component_b_overlay, {
        id: "split-panel-bottom",
        ref: "splitPanelBottom",
        class: "split-panel",
        show: $data.isBusyTable2
      }, {
        overlay: _withCtx(() => [
          _createVNode(_component_b_spinner, {
            small: "",
            type: "grow",
            variant: "secondary"
          }),
          _createVNode(_component_b_spinner, {
            style: {"animation-delay":"0.1s"},
            small: "",
            type: "grow",
            variant: "secondary"
          }),
          _createVNode(_component_b_spinner, {
            style: {"animation-delay":"0.2s"},
            small: "",
            type: "grow",
            variant: "secondary"
          })
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_14, [
            ($data.itemsTable2.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createElementVNode("h4", _hoisted_16, " Gefiltert: " + _toDisplayString($options.filteredItemsTable2.length) + " / Gesamt: " + _toDisplayString($data.itemsTable2.length), 1 /* TEXT */),
                  _createElementVNode("h4", _hoisted_17, _toDisplayString($options.filteredItemsTable2.length) + " / " + _toDisplayString($data.itemsTable2.length), 1 /* TEXT */)
                ]))
              : _createCommentVNode("v-if", true),
            _createElementVNode("div", _hoisted_18, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.filteredFieldsTable2, (field, index) => {
                return (_openBlock(), _createBlock(_component_b_button, {
                  key: index,
                  class: "filter-button d-none d-sm-block",
                  onClick: $event => ($options.clearFilter(field.filter))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(field.label) + " ", 1 /* TEXT */),
                    _cache[31] || (_cache[31] = _createElementVNode("i", { class: "fas fa-times" }, null, -1 /* CACHED */))
                  ]),
                  _: 2 /* DYNAMIC */
                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]))
              }), 128 /* KEYED_FRAGMENT */))
            ]),
            _createElementVNode("div", _hoisted_19, [
              _cache[37] || (_cache[37] = _createElementVNode("div", { style: {"color":"#7f7f7f"} }, " Vergleichssemester: ", -1 /* CACHED */)),
              _createVNode(_component_b_dropdown, {
                class: "mx-2",
                "no-flip": "",
                text: $data.comparativeSemester.short
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_20, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.semesters, (semester) => {
                      return (_openBlock(), _createBlock(_component_b_dropdown_item, {
                        key: semester.id,
                        onClick: $event => ($options.fetchDataTable2(semester))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(semester.short), 1 /* TEXT */)
                        ]),
                        _: 2 /* DYNAMIC */
                      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ])
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["text"]),
              _createVNode(_component_b_button_group, { style: {"width":"fit-content"} }, {
                default: _withCtx(() => [
                  _withDirectives((_openBlock(), _createBlock(_component_b_button, { title: "(Ausgewählte) E-mail-Adressen anzeigen" }, {
                    default: _withCtx(() => [...(_cache[32] || (_cache[32] = [
                      _createElementVNode("i", { class: "fas fa-envelope" }, null, -1 /* CACHED */)
                    ]))]),
                    _: 1 /* STABLE */
                  })), [
                    [_directive_b_modal, 'email-modal']
                  ]),
                  _createVNode(_component_b_modal, {
                    id: "email-modal",
                    title: "E-Mail Adressen",
                    "ok-only": ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_b_form_textarea, {
                        "model-value": $options.combinedMailAddresses.join('; '),
                        style: {"height":"100px"}
                      }, null, 8 /* PROPS */, ["model-value"])
                    ]),
                    _: 1 /* STABLE */
                  }),
                  _createVNode(_component_b_dropdown, {
                    title: "Anzuzeigende Spalten auswählen",
                    "auto-close": "outside",
                    right: "",
                    class: "btn-group"
                  }, {
                    "button-content": _withCtx(() => [...(_cache[33] || (_cache[33] = [
                      _createElementVNode("i", { class: "fas fa-th-list" }, null, -1 /* CACHED */)
                    ]))]),
                    default: _withCtx(() => [
                      _createVNode(_component_b_dropdown_form, { class: "bottom-panel-dropdown" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_b_form_checkbox, {
                            id: "all-columns-checkbox",
                            switch: "",
                            onChange: _cache[9] || (_cache[9] = $event => ($options.toggleShowAllColumns()))
                          }, {
                            default: _withCtx(() => [...(_cache[34] || (_cache[34] = [
                              _createTextVNode(" Alle Spalten ", -1 /* CACHED */)
                            ]))]),
                            _: 1 /* STABLE */
                          }),
                          _createVNode(_component_b_dropdown_divider),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.selectableFieldsTable2, (field) => {
                            return (_openBlock(), _createBlock(_component_b_form_checkbox, {
                              key: field.key,
                              modelValue: field.visible,
                              "onUpdate:modelValue": $event => ((field.visible) = $event)
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(field.label), 1 /* TEXT */)
                              ]),
                              _: 2 /* DYNAMIC */
                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["modelValue", "onUpdate:modelValue"]))
                          }), 128 /* KEYED_FRAGMENT */))
                        ]),
                        _: 1 /* STABLE */
                      })
                    ]),
                    _: 1 /* STABLE */
                  }),
                  _createVNode(_component_b_button, {
                    title: "Ausgewählte Spalten und Einträge als Excel-Datei herunterladen",
                    style: {"width":"56px"},
                    onClick: _cache[10] || (_cache[10] = $event => ($options.downloadTable2()))
                  }, {
                    default: _withCtx(() => [
                      (!$data.isExportingTable2)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [...(_cache[35] || (_cache[35] = [
                            _createElementVNode("i", { class: "fas fa-download" }, null, -1 /* CACHED */),
                            _createElementVNode("i", { class: "fas fa-file-excel" }, null, -1 /* CACHED */)
                          ]))]))
                        : (_openBlock(), _createBlock(_component_b_spinner, {
                            key: 1,
                            small: ""
                          }))
                    ]),
                    _: 1 /* STABLE */
                  }),
                  _createVNode(_component_b_button, {
                    title: "Alle Filter löschen",
                    onClick: _cache[11] || (_cache[11] = $event => ($options.clearFilters()))
                  }, {
                    default: _withCtx(() => [...(_cache[36] || (_cache[36] = [
                      _createElementVNode("i", { class: "fas fa-times" }, null, -1 /* CACHED */),
                      _createElementVNode("i", { class: "fas fa-filter" }, null, -1 /* CACHED */)
                    ]))]),
                    _: 1 /* STABLE */
                  })
                ]),
                _: 1 /* STABLE */
              })
            ], 512 /* NEED_PATCH */)
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createVNode(_component_b_table, {
              id: "table2",
              ref: "table2",
              busy: $data.isBusyTable2,
              "onUpdate:busy": _cache[19] || (_cache[19] = $event => (($data.isBusyTable2) = $event)),
              class: "bootstrap-vue-table-borders",
              striped: "",
              hover: "",
              small: "",
              responsive: "",
              "head-variant": "dark",
              "sticky-header": "100%",
              "primary-key": "contractId",
              fields: $options.visibleFieldsTable2,
              items: $options.filteredItemsTable2,
              "show-empty": "",
              selectable: "",
              "no-select-on-click": ""
            }, {
              "table-busy": _withCtx(() => [...(_cache[38] || (_cache[38] = [
                _createElementVNode("div", { class: "text-center my-3" }, " wird geladen... ", -1 /* CACHED */)
              ]))]),
              empty: _withCtx(() => [
                (!$data.errorTable2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, " Keine passenden Ergebnisse gefunden. "))
                  : (_openBlock(), _createElementBlock("div", _hoisted_24, [
                      _createElementVNode("div", _hoisted_25, " Ein Fehler ist aufgetreten (" + _toDisplayString($data.errorTable2.message) + "). ", 1 /* TEXT */),
                      _createVNode(_component_b_button, {
                        onClick: _cache[12] || (_cache[12] = $event => ($options.fetchDataTable2()))
                      }, {
                        default: _withCtx(() => [...(_cache[39] || (_cache[39] = [
                          _createElementVNode("i", { class: "fa-solid fa-rotate-right me-1" }, null, -1 /* CACHED */),
                          _createTextVNode("Erneut versuchen. ", -1 /* CACHED */)
                        ]))]),
                        _: 1 /* STABLE */
                      })
                    ]))
              ]),
              "head()": _withCtx(({ field }) => [
                _createElementVNode("div", null, _toDisplayString(field.label), 1 /* TEXT */),
                _createElementVNode("div", null, [
                  (field.filter && (field.filter.type === 'string-contains'
                    || field.filter.type === 'decimal-number-contains'))
                    ? (_openBlock(), _createBlock(_component_b_form_input, {
                        key: 0,
                        modelValue: field.filter.value,
                        "onUpdate:modelValue": $event => ((field.filter.value) = $event),
                        type: "text",
                        size: "sm",
                        placeholder: "Suchen...",
                        debounce: "200",
                        onClick: _cache[13] || (_cache[13] = _withModifiers(() => {}, ["stop"]))
                      }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue"]))
                    : _createCommentVNode("v-if", true),
                  (field.filter && field.filter.type === 'string-equals')
                    ? (_openBlock(), _createBlock(_component_b_form_input, {
                        key: 1,
                        modelValue: field.filter.value,
                        "onUpdate:modelValue": $event => ((field.filter.value) = $event),
                        type: "text",
                        size: "sm",
                        placeholder: "Gleich...",
                        debounce: "200",
                        onClick: _cache[14] || (_cache[14] = _withModifiers(() => {}, ["stop"]))
                      }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue"]))
                    : _createCommentVNode("v-if", true),
                  (field.filter && field.filter.type === 'multiselect')
                    ? (_openBlock(), _createBlock(_component_v_multiselect, {
                        key: 2,
                        modelValue: field.filter.value,
                        "onUpdate:modelValue": $event => ((field.filter.value) = $event),
                        options: field.filter.options,
                        multiple: true,
                        "track-by": "id",
                        label: "name",
                        "close-on-select": false,
                        "show-pointer": false,
                        "selected-label": "✓",
                        "open-direction": "bottom",
                        placeholder: "Filtern...",
                        onClick: _cache[15] || (_cache[15] = _withModifiers(() => {}, ["stop"]))
                      }, {
                        selection: _withCtx(({values, isOpen}) => [
                          (values.length > 1 && !isOpen)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(values.length) + " Werte", 1 /* TEXT */))
                            : (values.length === 1 && !isOpen)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(values[0].name), 1 /* TEXT */))
                              : (_openBlock(), _createElementBlock("span", _hoisted_28))
                        ]),
                        beforeList: _withCtx(() => [
                          _createElementVNode("li", {
                            class: "multiselect__option",
                            onClick: $event => (field.filter.value = [])
                          }, [...(_cache[40] || (_cache[40] = [
                            _createElementVNode("i", { class: "fas fa-times" }, null, -1 /* CACHED */),
                            _createTextVNode(" Filter löschen ", -1 /* CACHED */)
                          ]))], 8 /* PROPS */, _hoisted_29)
                        ]),
                        noResult: _withCtx(() => [...(_cache[41] || (_cache[41] = [
                          _createTextVNode(" Keine Inhalte gefunden. ", -1 /* CACHED */)
                        ]))]),
                        _: 2 /* DYNAMIC */
                      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["modelValue", "onUpdate:modelValue", "options"]))
                    : _createCommentVNode("v-if", true)
                ])
              ]),
              "head(select)": _withCtx(({selectAllRows, clearSelected}) => [
                _createVNode(_component_b_form_checkbox, {
                  modelValue: $options.allSelectedTable2,
                  "onUpdate:modelValue": [
                    _cache[16] || (_cache[16] = $event => (($options.allSelectedTable2) = $event)),
                    $event => ($options.allSelectedTable2 ? clearSelected() : selectAllRows())
                  ]
                }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue"])
              ]),
              "cell(select)": _withCtx(({index}) => [
                _createVNode(_component_b_form_checkbox, {
                  modelValue: $options.selectedRowsTable2[index],
                  "onUpdate:modelValue": [$event => (($options.selectedRowsTable2[index]) = $event), $event => ($options.toggleRowSelectionTable2(index))],
                  inline: ""
                }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue"])
              ]),
              "cell(lecturer)": _withCtx(({value}) => [
                _createElementVNode("a", {
                  href: $props.employeeBaseUrl + '/' + value.id + '/view',
                  target: "_blank"
                }, _toDisplayString(value.value), 9 /* TEXT, PROPS */, _hoisted_30)
              ]),
              "cell(emailWWU)": _withCtx(({field, value}) => [
                value
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      title: value
                    }, [
                      (field.filter.value === '')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                            _createElementVNode("a", {
                              href: 'mailto:' + value
                            }, [...(_cache[42] || (_cache[42] = [
                              _createElementVNode("i", { class: "fas fa-envelope" }, null, -1 /* CACHED */)
                            ]))], 8 /* PROPS */, _hoisted_33)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_34, [
                            _createElementVNode("a", {
                              href: 'mailto:' + value
                            }, _toDisplayString(value), 9 /* TEXT, PROPS */, _hoisted_35)
                          ]))
                    ], 8 /* PROPS */, _hoisted_31))
                  : _createCommentVNode("v-if", true)
              ]),
              "cell(coursesCL1)": _withCtx(({index, field, value : courses}) => [
                (courses.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                      (field.filter.value === '')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                            _createVNode(_component_b_button, {
                              id: 'courses-cl1-' + index,
                              size: "sm",
                              class: "text-nowrap"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Anzeigen (" + _toDisplayString(courses.length) + ") ", 1 /* TEXT */)
                              ]),
                              _: 2 /* DYNAMIC */
                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["id"]),
                            _createVNode(_component_b_popover, {
                              target: 'courses-cl1-' + index,
                              placement: "left",
                              click: "",
                              "close-on-hide": "",
                              lazy: ""
                            }, {
                              title: _withCtx(() => [
                                _createElementVNode("div", _hoisted_38, [
                                  _cache[44] || (_cache[44] = _createTextVNode(" Kurse VGS 1 ", -1 /* CACHED */)),
                                  _createVNode(_component_b_button, {
                                    title: "Veranstaltungstitel kopieren",
                                    size: "sm",
                                    class: "btn-smaller",
                                    onClick: $event => ($options.copyTitles(courses.map((course) => course.name)))
                                  }, {
                                    default: _withCtx(() => [...(_cache[43] || (_cache[43] = [
                                      _createElementVNode("i", { class: "fas fa-copy" }, null, -1 /* CACHED */)
                                    ]))]),
                                    _: 1 /* STABLE */
                                  }, 8 /* PROPS */, ["onClick"])
                                ])
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_b_table, {
                                  fields: [
                        {key: 'name', label: 'Veranstaltungstitel'},
                        {key: 'calculatedWorkload', label: 'Stunden'}
                      ],
                                  items: courses,
                                  "primary-key": "id",
                                  "sort-by": [{key: 'name', order: 'asc'}],
                                  small: "",
                                  borderless: "",
                                  "head-variant": "light",
                                  variant: "secondary",
                                  class: "mb-0"
                                }, {
                                  "cell(name)": _withCtx(({item}) => [
                                    _createElementVNode("a", {
                                      href: $props.courseBaseUrl + '/' + item.id + '/view',
                                      target: "_blank"
                                    }, _toDisplayString(item.name), 9 /* TEXT, PROPS */, _hoisted_39)
                                  ]),
                                  "cell(calculatedWorkload)": _withCtx(({value}) => [
                                    _createElementVNode("div", _hoisted_40, _toDisplayString($options.formatDuration(value)), 1 /* TEXT */)
                                  ]),
                                  _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["items"])
                              ]),
                              _: 2 /* DYNAMIC */
                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["target"])
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_41, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(courses.sort((a, b) => a.name.localeCompare(b.name, 'de-DE')), (course, key) => {
                              return (_openBlock(), _createElementBlock("div", { key: key }, [
                                ($options.sanitizeString(course.name).includes($options.sanitizeString(field.filter.value)))
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 0,
                                      href: $props.courseBaseUrl + '/' + course.id + '/view',
                                      target: "_blank"
                                    }, _toDisplayString(course.name), 9 /* TEXT, PROPS */, _hoisted_42))
                                  : _createCommentVNode("v-if", true)
                              ]))
                            }), 128 /* KEYED_FRAGMENT */))
                          ]))
                    ]))
                  : _createCommentVNode("v-if", true)
              ]),
              "cell(coursesCL2)": _withCtx(({index, field, value : courses}) => [
                (courses.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                      (field.filter.value === '')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                            _createVNode(_component_b_button, {
                              id: 'courses-cl2-' + index,
                              size: "sm",
                              class: "text-nowrap"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Anzeigen (" + _toDisplayString(courses.length) + ") ", 1 /* TEXT */)
                              ]),
                              _: 2 /* DYNAMIC */
                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["id"]),
                            _createVNode(_component_b_popover, {
                              target: 'courses-cl2-' + index,
                              placement: "right",
                              click: "",
                              "close-on-hide": "",
                              lazy: ""
                            }, {
                              title: _withCtx(() => [
                                _createElementVNode("div", _hoisted_45, [
                                  _cache[46] || (_cache[46] = _createTextVNode(" Kurse VGS 2 ", -1 /* CACHED */)),
                                  _createVNode(_component_b_button, {
                                    title: "Veranstaltungstitel kopieren",
                                    size: "sm",
                                    class: "btn-smaller",
                                    onClick: $event => ($options.copyTitles(courses.map((course) => course.name)))
                                  }, {
                                    default: _withCtx(() => [...(_cache[45] || (_cache[45] = [
                                      _createElementVNode("i", { class: "fas fa-copy" }, null, -1 /* CACHED */)
                                    ]))]),
                                    _: 1 /* STABLE */
                                  }, 8 /* PROPS */, ["onClick"])
                                ])
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_b_table, {
                                  fields: [
                        {key: 'name', label: 'Veranstaltungstitel'},
                        {key: 'calculatedWorkload', label: 'Stunden'}
                      ],
                                  items: courses,
                                  "primary-key": "id",
                                  "sort-by": [{key: 'name', order: 'asc'}],
                                  small: "",
                                  borderless: "",
                                  "head-variant": "light",
                                  variant: "secondary",
                                  class: "mb-0"
                                }, {
                                  "cell(name)": _withCtx(({item}) => [
                                    _createElementVNode("a", {
                                      href: $props.courseBaseUrl + '/' + item.id + '/view',
                                      target: "_blank"
                                    }, _toDisplayString(item.name), 9 /* TEXT, PROPS */, _hoisted_46)
                                  ]),
                                  "cell(calculatedWorkload)": _withCtx(({value}) => [
                                    _createElementVNode("div", _hoisted_47, _toDisplayString($options.formatDuration(value)), 1 /* TEXT */)
                                  ]),
                                  _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["items"])
                              ]),
                              _: 2 /* DYNAMIC */
                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["target"])
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_48, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(courses.sort((a, b) => a.name.localeCompare(b.name, 'de-DE')), (course, key) => {
                              return (_openBlock(), _createElementBlock("div", { key: key }, [
                                ($options.sanitizeString(course.name).includes($options.sanitizeString(field.filter.value)))
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 0,
                                      href: $props.courseBaseUrl + '/' + course.id + '/view',
                                      target: "_blank"
                                    }, _toDisplayString(course.name), 9 /* TEXT, PROPS */, _hoisted_49))
                                  : _createCommentVNode("v-if", true)
                              ]))
                            }), 128 /* KEYED_FRAGMENT */))
                          ]))
                    ]))
                  : _createCommentVNode("v-if", true)
              ]),
              "cell(processingStatus)": _withCtx(({index, item, value, unformatted}) => [
                _createElementVNode("div", {
                  ref: 'processingStatusWrapper' + index,
                  class: "d-flex justify-content-between align-items-start"
                }, [
                  _createElementVNode("div", null, _toDisplayString(value), 1 /* TEXT */),
                  _createVNode(_component_b_button, {
                    id: 'processing-status-btn' + index,
                    size: "sm",
                    class: "btn-smaller"
                  }, {
                    default: _withCtx(() => [...(_cache[47] || (_cache[47] = [
                      _createElementVNode("i", { class: "fas fa-edit" }, null, -1 /* CACHED */)
                    ]))]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["id"])
                ], 512 /* NEED_PATCH */),
                _createVNode(_component_b_popover, {
                  ref: 'processingStatusPopover' + index,
                  target: 'processing-status-btn' + index,
                  placement: "left",
                  title: "Bearbeitungsstatus aktualisieren",
                  click: "",
                  "close-on-hide": "",
                  lazy: "",
                  onShown: $event => (_ctx.$refs['processingStatusSelect' + index].$el.focus())
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_b_form, {
                      onSubmit: _withModifiers($event => ($options.submitProcessingStatus(
                    item['contractId'],
                    $event,
                    _ctx.$refs['processingStatusPopover' + index],
                    _ctx.$refs['processingStatusWrapper' + index].parentNode
                  )), ["prevent"])
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_50, [
                          _createVNode(_component_b_form_select, {
                            ref: 'processingStatusSelect' + index,
                            name: "status",
                            "model-value": unformatted ? unformatted : 'open',
                            onKeydown: [
                              _withKeys($event => (_ctx.$refs['processingStatusSubmit' + index].focus()), ["enter"]),
                              _withKeys($event => (_ctx.$refs['processingStatusPopover' + index].hide()), ["esc"])
                            ]
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_b_form_select_option, { value: "open" }, {
                                default: _withCtx(() => [...(_cache[48] || (_cache[48] = [
                                  _createTextVNode(" offen ", -1 /* CACHED */)
                                ]))]),
                                _: 1 /* STABLE */
                              }),
                              _createVNode(_component_b_form_select_option, { value: "transferred" }, {
                                default: _withCtx(() => [...(_cache[49] || (_cache[49] = [
                                  _createTextVNode(" übertragen ", -1 /* CACHED */)
                                ]))]),
                                _: 1 /* STABLE */
                              }),
                              _createVNode(_component_b_form_select_option, { value: "granted" }, {
                                default: _withCtx(() => [...(_cache[50] || (_cache[50] = [
                                  _createTextVNode(" erteilt ", -1 /* CACHED */)
                                ]))]),
                                _: 1 /* STABLE */
                              }),
                              _createVNode(_component_b_form_select_option, { value: "correct" }, {
                                default: _withCtx(() => [...(_cache[51] || (_cache[51] = [
                                  _createTextVNode(" korrekter Nachweis ", -1 /* CACHED */)
                                ]))]),
                                _: 1 /* STABLE */
                              }),
                              _createVNode(_component_b_form_select_option, { value: "incorrect" }, {
                                default: _withCtx(() => [...(_cache[52] || (_cache[52] = [
                                  _createTextVNode(" inkorrekter Nachweis ", -1 /* CACHED */)
                                ]))]),
                                _: 1 /* STABLE */
                              })
                            ]),
                            _: 1 /* STABLE */
                          }, 8 /* PROPS */, ["model-value", "onKeydown"]),
                          _createVNode(_component_b_button, {
                            ref: 'processingStatusSubmit' + index,
                            type: "submit",
                            variant: "primary",
                            class: "ms-2",
                            style: {"width":"54px"},
                            onKeydown: [
                              _withKeys(_withModifiers($event => (_ctx.$refs['processingStatusSelect' + index].$el.focus()), ["prevent"]), ["tab"]),
                              _withKeys($event => (_ctx.$refs['processingStatusPopover' + index].hide()), ["esc"])
                            ]
                          }, {
                            default: _withCtx(() => [...(_cache[53] || (_cache[53] = [
                              _createTextVNode(" OK ", -1 /* CACHED */)
                            ]))]),
                            _: 1 /* STABLE */
                          }, 8 /* PROPS */, ["onKeydown"])
                        ])
                      ]),
                      _: 2 /* DYNAMIC */
                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onSubmit"])
                  ]),
                  _: 2 /* DYNAMIC */
                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["target", "onShown"])
              ]),
              "cell(difference)": _withCtx(({value, unformatted}) => [
                _createElementVNode("div", {
                  style: _normalizeStyle({color: unformatted < 0 ? 'red' : null})
                }, _toDisplayString(value), 5 /* TEXT, STYLE */)
              ]),
              "cell(comment)": _withCtx(({index, item, field, value}) => [
                _createElementVNode("div", {
                  ref: 'commentWrapper' + index,
                  class: _normalizeClass(value ? 'text-center' : 'float-end')
                }, [
                  (field.filter.value === '')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                        _createVNode(_component_b_button, {
                          id: 'comment-target-' + index,
                          size: "sm",
                          class: "text-nowrap"
                        }, {
                          default: _withCtx(() => [
                            value
                              ? (_openBlock(), _createElementBlock("span", _hoisted_52, "Anzeigen"))
                              : (_openBlock(), _createElementBlock("i", _hoisted_53))
                          ]),
                          _: 2 /* DYNAMIC */
                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["id"])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_54, [
                        ($options.sanitizeString(value).includes($options.sanitizeString(field.filter.value)))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_55, _toDisplayString(value), 1 /* TEXT */))
                          : _createCommentVNode("v-if", true)
                      ])),
                  _createVNode(_component_b_popover, {
                    ref: 'commentPopover' + index,
                    placement: "left",
                    target: 'comment-target-' + index,
                    click: "",
                    "close-on-hide": "",
                    lazy: "",
                    onShow: $event => (($data.commentPopoverIndex !== null) ? $event.preventDefault() : $options.openCommentPopover(index, !value)),
                    onHide: _cache[18] || (_cache[18] = $event => ($data.editingComment ? $event.preventDefault() : $data.commentPopoverIndex = null))
                  }, {
                    title: _withCtx(() => [
                      _createElementVNode("div", _hoisted_56, [
                        _createElementVNode("div", null, [
                          _cache[54] || (_cache[54] = _createTextVNode("Bemerkung ", -1 /* CACHED */)),
                          ($data.editingComment)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_57, _toDisplayString(value ? 'bearbeiten' : 'erstellen'), 1 /* TEXT */))
                            : _createCommentVNode("v-if", true)
                        ]),
                        (!$data.editingComment)
                          ? (_openBlock(), _createBlock(_component_b_button_group, { key: 0 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_b_button, {
                                  title: "Bemerkung bearbeiten",
                                  size: "sm",
                                  class: "btn-smaller",
                                  onClick: _cache[17] || (_cache[17] = $event => ($data.editingComment=true))
                                }, {
                                  default: _withCtx(() => [...(_cache[55] || (_cache[55] = [
                                    _createElementVNode("i", { class: "fas fa-edit" }, null, -1 /* CACHED */)
                                  ]))]),
                                  _: 1 /* STABLE */
                                }),
                                _createVNode(_component_b_button, {
                                  ref: 'deleteCommentButton' + index,
                                  title: "Bemerkung löschen",
                                  variant: "danger",
                                  size: "sm",
                                  class: "btn-smaller",
                                  onClick: $event => ($options.confirmCommentDelete(item, index))
                                }, {
                                  default: _withCtx(() => [...(_cache[56] || (_cache[56] = [
                                    _createElementVNode("i", { class: "fas fa-trash" }, null, -1 /* CACHED */)
                                  ]))]),
                                  _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["onClick"])
                              ]),
                              _: 2 /* DYNAMIC */
                            }, 1024 /* DYNAMIC_SLOTS */))
                          : (_openBlock(), _createBlock(_component_b_button, {
                              key: 1,
                              size: "sm",
                              class: "btn-smaller",
                              onClick: $event => ($options.closeCommentPopover(index))
                            }, {
                              default: _withCtx(() => [...(_cache[57] || (_cache[57] = [
                                _createTextVNode(" Schließen ", -1 /* CACHED */)
                              ]))]),
                              _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["onClick"]))
                      ])
                    ]),
                    default: _withCtx(() => [
                      (!$data.editingComment)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_58, _toDisplayString(value), 1 /* TEXT */))
                        : (_openBlock(), _createBlock(_component_b_form, {
                            key: 1,
                            onSubmit: _withModifiers($event => ($options.submitComment(
                      item['contractId'],
                      $event,
                      _ctx.$refs['commentPopover' + index],
                      _ctx.$refs['commentWrapper' + index].parentNode
                    )), ["prevent"])
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_59, [
                                _createVNode(_component_b_form_textarea, {
                                  ref: 'commentTextArea' + index,
                                  "model-value": value,
                                  name: "comment",
                                  size: "sm",
                                  "no-resize": "",
                                  "max-rows": "6"
                                }, null, 8 /* PROPS */, ["model-value"]),
                                _createVNode(_component_b_button, {
                                  type: "submit",
                                  variant: "primary",
                                  class: "ms-2",
                                  style: {"width":"54px","height":"min-content"}
                                }, {
                                  default: _withCtx(() => [...(_cache[58] || (_cache[58] = [
                                    _createTextVNode(" OK ", -1 /* CACHED */)
                                  ]))]),
                                  _: 1 /* STABLE */
                                })
                              ])
                            ]),
                            _: 2 /* DYNAMIC */
                          }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onSubmit"]))
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["target", "onShow"])
                ], 2 /* CLASS */)
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["busy", "fields", "items"])
          ])
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["show"])
    ], 512 /* NEED_PATCH */),
    _createVNode(_component_b_modal, {
      id: "delete-comment-modal",
      ref: "deleteCommentModal",
      variant: "danger",
      title: "Bestätigung erforderlich",
      onClose: _cache[21] || (_cache[21] = $event => {$data.deleteCommentData = null;})
    }, {
      footer: _withCtx(({close}) => [
        _createVNode(_component_b_button, {
          onClick: $event => (close())
        }, {
          default: _withCtx(() => [...(_cache[63] || (_cache[63] = [
            _createTextVNode(" Abbrechen ", -1 /* CACHED */)
          ]))]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["onClick"]),
        _createVNode(_component_b_button, {
          ref: "deleteCommentButton",
          variant: "danger",
          onClick: _cache[20] || (_cache[20] = $event => ($options.deleteComment()))
        }, {
          default: _withCtx(() => [...(_cache[64] || (_cache[64] = [
            _createTextVNode(" Löschen ", -1 /* CACHED */)
          ]))]),
          _: 1 /* STABLE */
        }, 512 /* NEED_PATCH */)
      ]),
      default: _withCtx(() => [
        _cache[65] || (_cache[65] = _createElementVNode("h5", null, "Möchten Sie die folgende Bemerkung wirklich löschen?", -1 /* CACHED */)),
        _createElementVNode("div", _hoisted_60, [
          _createElementVNode("p", null, [
            _cache[60] || (_cache[60] = _createElementVNode("b", null, "Name: ", -1 /* CACHED */)),
            _createTextVNode(_toDisplayString($data.deleteCommentData ? $data.deleteCommentData['name'] : ''), 1 /* TEXT */)
          ]),
          _createElementVNode("p", null, [
            _cache[61] || (_cache[61] = _createElementVNode("b", null, "Vertrag: ", -1 /* CACHED */)),
            _createTextVNode(_toDisplayString($data.deleteCommentData ? $data.deleteCommentData['contractType'] : ''), 1 /* TEXT */)
          ]),
          _createElementVNode("p", null, [
            _cache[62] || (_cache[62] = _createElementVNode("b", null, "Bemerkung: ", -1 /* CACHED */)),
            _createTextVNode(_toDisplayString($data.deleteCommentData ? $data.deleteCommentData['comment'] : ''), 1 /* TEXT */)
          ])
        ])
      ]),
      _: 1 /* STABLE */
    }, 512 /* NEED_PATCH */)
  ]))
}